var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 25.5V6.5H27.5V25.5H4.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19C11.5523 19 12 18.5523 12 18C12 17.4477 11.5523 17 11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18L11 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H25",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDiscount);
export default __webpack_public_path__ + "static/media/VolumeDiscount.f013e314.svg";
export { ForwardRef as ReactComponent };